import { jsx as _jsx } from "react/jsx-runtime";
import { useReactiveVar } from "@apollo/client";
import ModalConfirmation from './ModalConfirmation';
import { showTimeoutVar } from '../helpers/client';
const TimeoutScreen = ({ message }) => {
    const showTimeout = useReactiveVar(showTimeoutVar);
    const defaultMessage = "This is taking longer than we thought.  It should work if you keep waiting, or you can refresh the page to try again.";
    return showTimeout && (_jsx(ModalConfirmation, { message: message || defaultMessage, buttonConfirm: () => showTimeoutVar(false), buttonConfirmContents: `Ok` }));
};
export default TimeoutScreen;
